const animationConfig = {
  speeds: {
    initial: 1,
    accelerated: 0.5,
  },
};
export default animationConfig;
